import React from 'react';
import { FaCheck } from 'react-icons/fa';

/**
 * Horizontal create-flow stepper: numbered circles + connector lines.
 * @param {{ id: string, label: string, disabled?: boolean }[]} steps
 * @param {string} activeStepId
 * @param {(id: string) => void} onStepChange
 */
export default function EatsAdminCreateStepper({ steps = [], activeStepId, onStepChange }) {
  const activeIndex = Math.max(
    0,
    steps.findIndex((step) => step.id === activeStepId),
  );

  return (
    <nav className="eats-admin-stepper" aria-label="Creation steps">
      <ol className="eats-admin-stepper__list">
        {steps.map((step, index) => {
          const isActive = step.id === activeStepId;
          const isComplete = index < activeIndex;
          const isDisabled = Boolean(step.disabled) && !isActive && !isComplete;
          const stateClass = isActive
            ? ' is-active'
            : isComplete
              ? ' is-complete'
              : isDisabled
                ? ' is-disabled'
                : '';

          return (
            <li key={step.id} className={`eats-admin-stepper__item${stateClass}`}>
              {index > 0 ? (
                <div
                  className={`eats-admin-stepper__connector${
                    index <= activeIndex ? ' is-filled' : ''
                  }`}
                  aria-hidden="true"
                />
              ) : null}
              <button
                type="button"
                className="eats-admin-stepper__btn"
                onClick={() => {
                  if (isDisabled) return;
                  onStepChange?.(step.id);
                }}
                disabled={isDisabled}
                aria-current={isActive ? 'step' : undefined}
              >
                <span className="eats-admin-stepper__circle" aria-hidden="true">
                  {isComplete ? <FaCheck /> : index + 1}
                </span>
                <span className="eats-admin-stepper__meta">
                  <span className="eats-admin-stepper__index">Step {index + 1}</span>
                  <span className="eats-admin-stepper__label">{step.label}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
